import i18n from '@/tools/i18n'
const commonfun = {
  // 定义一个对象专门用来存储本地缓存
  localStorage: {
    // 存
    setitem: function (key, value) {
      window.localStorage.setItem(key, value)
    },
    // 取
    getitem: function (key) {
      return window.localStorage.getItem(key)
    },
    // 移出
    removeitem: function (key) {
      window.localStorage.removeItem(key)
    },
    // 清空所有
    clearall: function () {
      window.localStorage.clear()
    }
  },
  // 配置企微的通讯录组件展示
  // 接收三个参数
  // type类型string是开放数据类型
  // openid类型string是数据ID，根据type取值而定
  // type的合法值
  // userName用户名称
  // departmentName部门名称
  RenderWxName: function (type, openid) {
    if (openid) {
      var openidstr = openid.slice(0, 3)
      if (openidstr === 'wx|' && JSON.parse(commonfun.localStorage.getitem('qyuser'))) {
        return '<ww-open-data type="' + type + '" openid="' + openid.slice(3) + '"></ww-open-data>'
      } else {
        return openid
      }
    } else {
      return openid
    }
  },
  // 将数据处理成组织树架构
  // 参数说明，data--数据源，childrenName--子集key名称，idName--idkey名称，parentIdName父集keyid名称
  toTree: function (data, childrenName, idName, parentIdName) {
    // 删除 所有 children,以防止多次调用
    data.forEach(function (item) {
      delete item[childrenName]
    })
    // 将数据存储为 以 id 为 KEY 的 map 索引数据列
    var map = {}
    data.forEach(function (item) {
      map[item[idName]] = item
    })
    var val = []
    data.forEach(function (item) {
      // 以当前遍历项，的pid,去map对象中找到索引的id
      var parent = map[item[parentIdName]]
      // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
      if (parent) {
        (parent[childrenName] || (parent[childrenName] = [])).push(item)
      } else {
        // 如果没有在map中找到对应的索引ID,那么直接把当前的item添加到val结果集中，作为顶级
        if (val.length === 0) {
          val.push(item)
        }
      }
    })
    return val
  },
  // 地区组织树架构
  // 参数说明，data--数据源，childrenName--子集key名称，idName--idkey名称，parentIdName父集keyid名称
  toRegionTree: function (data, childrenName, idName, parentIdName) {
    // 删除 所有 children,以防止多次调用
    data.forEach(function (item) {
      delete item[childrenName]
    })
    // 将数据存储为 以 id 为 KEY 的 map 索引数据列
    var map = {}
    data.forEach(function (item) {
      map[item[idName]] = item
    })
    var val = []
    data.forEach(function (item) {
      // 以当前遍历项，的pid,去map对象中找到索引的id
      var parent = map[item[parentIdName]]
      // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
      if (parent) {
        (parent[childrenName] || (parent[childrenName] = [])).push(item)
      } else {
        // 如果没有在map中找到对应的索引ID,那么直接把当前的item添加到val结果集中，作为顶级
        if (val.length === 0) {
          val.push(item)
        }
      }
    })
    return val
  },

  // 分类组织树架构
  // 参数说明，data--数据源，childrenName--子集key名称，idName--idkey名称，parentIdName父集keyid名称
  toCategoryTree: function (data, childrenName, idName, parentIdName) {
    // 删除 所有 children,以防止多次调用
    data.forEach(function (item) {
      delete item[childrenName]
    })
    // 将数据存储为 以 id 为 KEY 的 map 索引数据列
    var map = {}
    data.forEach(function (item) {
      map[item[idName]] = item
    })
    var val = []
    data.forEach(function (item) {
      // 以当前遍历项，的pid,去map对象中找到索引的id
      var parent = map[item[parentIdName]]
      // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
      if (parent) {
        (parent[childrenName] || (parent[childrenName] = [])).push(item)
      } else {
        // 如果没有在map中找到对应的索引ID,那么直接把当前的item添加到val结果集中，作为顶级
        if (val.length === 0) {
          val.push(item)
        }
      }
    })
    return val
  },

  // 判断一个元素是不是属于该数组
  IsInArray: function (arr, val) {
    var testStr = ',' + arr.join(',') + ','
    return testStr.indexOf(',' + val + ',') !== -1
  },
  /**
   * 公用提示窗
   * @param {string} [desc] 弹框提示文字
   * @param {string} [title] 弹框标题
   * @param {string} [confirmButtonName] 确认按钮文字
   * @param {string} [cancelButtonName] 取消按钮文字
   * @param {boolean} [distinguishCancelAndClose] 是否将取消（点击取消按钮）与关闭（点击关闭按钮或遮罩层、按下 ESC 键）进行区分
   * @param {string} [type] success / info / warning / error
   * @param {string} [that] this指向
   * @returns
   */
  confirm: function (desc, title, confirmButtonName, cancelButtonName, distinguishCancelAndClose, type, that) {
    return that.$confirm(desc, title, {
      confirmButtonText: confirmButtonName,
      cancelButtonText: cancelButtonName,
      distinguishCancelAndClose: distinguishCancelAndClose,
      closeOnClickModal: false,
      type: type,
      center: false
    })
  },
  // 判断字符串是否为纯空格
  // 为空或纯空格为true有值为false
  isNull: function (str) {
    if (str === '') return true
    var regu = '^[ ]+$'
    var re = new RegExp(regu)
    return re.test(str)
  },
  // encode编码
  encodeUrl: function (value) {
    return encodeURIComponent(value)
  },
  decodeUrl: function (value) {
    return decodeURIComponent(value)
  },
  // 时间格式转化  先统一转为时间戳
  // type为需要转换的时间格式
  // type:1 转为  2020-07-27 20:40
  // type:2 转为  2020-07-27
  // type:3 转为  2020-07-27 20:40:14
  // type:4 转为  20200727204014123
  formatDate: function (value, type) {
    if (value) {
      var timestamp = Date.parse(new Date(value))
      const date = new Date(timestamp)
      const y = date.getFullYear()
      let MM = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h = date.getHours()
      h = h < 10 ? ('0' + h) : h
      let m = date.getMinutes()
      m = m < 10 ? ('0' + m) : m
      let s = date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      const ms = date.getMilliseconds()
      switch (type) {
        case '1':
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m
        case '2':
          return y + '-' + MM + '-' + d
        case '3':
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
        case '4':
          return y + '' + MM + '' + d + '' + h + '' + m + '' + s + '' + ms
      }
    } else {
      return ''
    }
  },
  // 是否企微同步  true是  false否
  isQySynchronization: function (value) {
    if (value) {
      return i18n.t('LanguageLib.YES')
    } else {
      return i18n.t('LanguageLib.NO')
    }
  },
  // 是否企微同步判断微信状态 0：非微信用户 1：微信绑定 2：取消微信绑定即1为是企微同步其他都不是企微同步
  isQySynchronization1: function (value) {
    if (value === 1) {
      return i18n.t('LanguageLib.YES')
    } else {
      return i18n.t('LanguageLib.NO')
    }
  },
  // 企微绑定状态
  authStatus: function (value) {
    if (value === 2) {
      return i18n.t('LanguageLib.Unbundling')
    } else if (value === 1) {
      return i18n.t('LanguageLib.Binding')
    } else {
      return ''
    }
  },
  // 用户类型列表
  // 用户类型列表-1:无1：零售管理2：店铺管理3：店铺员工4：非零售系统
  getUserTypeName: function (value) {
    if (value) {
      switch (value) {
        case -1:
          return '-'
        case 1:
          return i18n.t('LanguageLib.RETAIL_MANAGEMENT')
        case 2:
          return i18n.t('LanguageLib.STORE_MANAGEMENT')
        case 3:
          return i18n.t('LanguageLib.Store_Staff')
        case 4:
          return i18n.t('LanguageLib.Non_Retail_System')
      }
    } else {
      return '-'
    }
  },
  // 人员状态
  // 状态0：正常1：休假
  getPeopleStatus: function (value) {
    if (value === 0) {
      return i18n.t('LanguageLib.z_info_common_000087')
    } else if (value === 1) {
      return i18n.t('LanguageLib.Vacation')
    } else if (value === 2) {
      return i18n.t('LanguageLib.USER_STATUS_QUIT')
    } else {
      return ''
    }
  },
  // 用户性别0：女1：男2：未指定
  getGender: function (value) {
    if (value === 0) {
      return i18n.t('LanguageLib.FEMALE')
    } else if (value === 1) {
      return i18n.t('LanguageLib.MALE')
    } else {
      return i18n.t('LanguageLib.UNSPECIFIED')
    }
  },
  /**
   * 字符串去除空格
   * @param {string} [type] head / tail / all /
   * @returns
   */
  trim: function (type, value) {
    switch (type) {
      case 'head':
        return value.replace(/(^\s*)/g, '')
      case 'tail':
        return value.replace(/(\s*$)/g, '')
      case 'all':
        return value.replace(/(^\s*)|(\s*$)/g, '')
    }
  },
  // 是否企微字段
  iswx: function (value) {
    if (value === null) {
      return false
    } else {
      if (value.slice(0, 3) === 'wx|') {
        return true
      } else {
        return false
      }
    }
  },
  convertType (mycase) {
    var type
    switch (mycase) {
      case 0: {
        type = '单行文本'
        break }
      case 1: {
        type = '多行文本'
        break
      }
      case 2: {
        type = '单选'
        break
      }
      case 3: {
        type = '多选'
        break
      }
      case 4: {
        type = '日期'
        break
      }
      case 5: {
        type = '时间'
        break
      }
      case 6: {
        type = '数值'
        break
      }
      case 7: {
        type = '附件 '
        break
      }
      case 8: {
        type = '日期 + 日期'
        break
      }
    }
    return type
  },
  console: {
    log: function (value) {
      const isDev = process.env.NODE_ENV
      switch (isDev) {
        case 'development' :
          return console.log(value)
        case 'pre' :
          break
        case 'production' :
          break
        case 'dev' :
          return console.log(value)
      }
    }
  },
  // 机械臂状态
  ArmStatus: function (value) {
    if (value === 'OFFLINE') {
      return i18n.t('LanguageLib.OFFLINE')
    } else if (value === 'ONLINE') {
      return i18n.t('LanguageLib.ONLINE')
    } else {
      return ''
    }
  },
  // 导入助手-导入类型
  ImportType: function (value) {
    switch (value) {
      case 1000 :
        return i18n.t('LanguageLib.STAFF_MANAGEMENT') + i18n.t('LanguageLib.IMPORT')
      case 1010 :
        return i18n.t('LanguageLib.QYUSER') + i18n.t('LanguageLib.IMPORT')
      case 2000 :
        return i18n.t('LanguageLib.STORE_MANAGEMENT') + i18n.t('LanguageLib.IMPORT')
      case 3000 :
        return i18n.t('LanguageLib.SHOP_EQUIPMENT') + i18n.t('LanguageLib.IMPORT')
      case 4000 :
        return i18n.t('LanguageLib.DISPLAY_BROCHURE') + i18n.t('LanguageLib.IMPORT')
      case 5000 :
        return i18n.t('LanguageLib.TEST_QUESTION') + i18n.t('LanguageLib.IMPORT')
      case 6000 :
        return i18n.t('LanguageLib.MAINTENANCE_CLASSIFICATION_IMPORT')
      case 7000 :
        return i18n.t('LanguageLib.MAINTENANCE_FAULT_IMPORT')
      case 8000 :
        return i18n.t('LanguageLib.ITEM_CLASSIFICATION_IMPORT')
      case 9000 :
        return i18n.t('LanguageLib.ITEM_INFORMATION') + i18n.t('LanguageLib.IMPORT')
      case 10000 :
        return i18n.t('LanguageLib.SHOP_PROPS_IMPORT')
      case 11000 :
        return i18n.t('LanguageLib.ROLES') + i18n.t('LanguageLib.IMPORT')
      case 12000 :
        return i18n.t('LanguageLib.DISPLAY_BROCHURE_RELATIONSHIP') + i18n.t('LanguageLib.IMPORT')
      case 13000 :
        return i18n.t('LanguageLib.ITEM_INVENTORY') + i18n.t('LanguageLib.IMPORT')
      case 14000 :
        return i18n.t('LanguageLib.USER_JOB_INFORMATION_IMPORT')
      case 15000 :
        return i18n.t('LanguageLib.KPI_SALES_TARGET') + i18n.t('LanguageLib.IMPORT')
      case 16000 :
        return i18n.t('LanguageLib.SHOP_TOUR_TEMPLATE') + i18n.t('LanguageLib.IMPORT')
      case 21000 :
        return i18n.t('LanguageLib.ORGANIZATION1') + i18n.t('LanguageLib.IMPORT')
      case 26000 :
        return i18n.t('LanguageLib.STORE_LONG_FORM') + i18n.t('LanguageLib.IMPORT')
      case 31000 :
        return i18n.t('LanguageLib.BINDING_QY_DEPARTMENT') + i18n.t('LanguageLib.IMPORT')
    }
  },
  // 将布尔值转允许或者不允许字段
  showAllowStr: function (value) {
    if (value) {
      return i18n.t('LanguageLib.ALLOW')
    } else {
      return i18n.t('LanguageLib.NOT_ALLOW')
    }
  },
  // 将布尔值转有或者无字段
  showHaveStr: function (value) {
    if (value) {
      return i18n.t('LanguageLib.HAVE')
    } else {
      return i18n.t('LanguageLib.NO1')
    }
  },
  /**
   * 字符串替换指定数据
   * @param {string} [value] 需要替换的字符
   * @param {} [data] 需要替换的数据
   * @returns
   */
  StrReplace: function (value, data) {
    return value.replace(/\{(.+?)\}/g, data)
  },
  /**
   * 字符串替换指定数据
   * demo stringFormat('我是{0}，今年{1}，性别{2}', '魏超', 38, '男')
   * return "我是魏超，今年38，性别男"
   */
  stringFormat: function () {
    if (arguments.length === 0) {
      return null
    }
    var str = arguments[0]
    for (var i = 1; i < arguments.length; i++) {
      var re = new RegExp('\\{' + (i - 1) + '\\}', 'gm')
      str = str.replace(re, arguments[i])
    }
    return str
  }
}

export default commonfun
